import { BoardColumns } from '../board-table/boardColumns';

export const kTaskColumns = {
  plate: { title: '车牌号', flex: 2 },
  customer: { title: '客户', flex: 1.3 },
  preInspection: { title: '预检', flex: 1.2 },
  inspection: { title: '检测', flex: 1.2 },
  construction: { title: '施工', flex: 1.2 },
  createdAt: { title: '开单时间', flex: 1.5 },
  elapsed: { title: '已用时', flex: 1.4 },
} satisfies BoardColumns;
